run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'workplan']

export default function run ($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, workplan, GlobalConfig) {
  $templateCache.put('proposals-list', require('./projectFormulation/list/proposals-list.html'))
  $templateCache.put('proposals-details', require('./projectFormulation/list/proposals-details.html'))
  $templateCache.put('list-data-proposals', require('./projectFormulation/list/proposals/list-data-proposals.html'))
  $templateCache.put('details-header-proposal', require('./projectFormulation/list/details/details-header-proposal.html'))
  $templateCache.put('header-proposals', require('./projectFormulation/list/header-proposals.html'))

  $templateCache.put('extension-projects-list', require('./extensionProjects/list/extension-projects-list.html'))
  $templateCache.put('extension-projects-details', require('./extensionProjects/list/extension-projects-details.html'))
  $templateCache.put('list-data-projects', require('./extensionProjects/list/projects/list-data-projects.html'))
  $templateCache.put('extension-details-header-projects', require('./extensionProjects/list/details/extension-details-header-projects.html'))
  $templateCache.put('extension-header-projects', require('./extensionProjects/list/extension-header-projects.html'))

  $templateCache.put('visibility-list', require('./visibility/list/visibility-list.html'))
  $templateCache.put('visibility-details', require('./visibility/list/visibility-details.html'))
  $templateCache.put('list-data-visibility', require('./visibility/list/projects/list-data-visibility.html'))
  $templateCache.put('visibility-details-header', require('./visibility/list/details/visibility-details-header.html'))
  $templateCache.put('visibility-header', require('./visibility/list/visibility-header.html'))
}




// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/extensionVisibility/extension.run.js